import { createSelector } from 'reselect';
import { getValue } from '../constants/getFieldValues';
import { CHANGE_NAME } from '../constants/child';
import { PersonFields } from '../models/person';
import { isNameValid, notEmptyField } from '../validators/common';
import { CITIZENSHIP } from '../constants/citizenship';

export const getPerson: (state: { person: PersonFields }) => PersonFields = (
  state
) => state.person;

export const getPersonChangeName: (state: {
  person: PersonFields;
}) => CHANGE_NAME | null = createSelector(getPerson, ({ changeName }) =>
  getValue(changeName)
);

export const didPersonChangedName: (state: {
  person: PersonFields;
}) => boolean = createSelector(
  getPersonChangeName,
  (changeName) => changeName === CHANGE_NAME.notMatch
);

export const getPersonChangeNameDocIssuer: (state: {
  person: PersonFields;
}) => string = createSelector(getPerson, ({ changeNameDocIssuer }) =>
  getValue(changeNameDocIssuer)
);

export const validatePersonChangeName = createSelector(
  getPersonChangeName,
  (value) => !value
);

export const getPersonChangedName: (state: {
  person: PersonFields;
}) => string = createSelector(getPerson, ({ changedName }) =>
  getValue(changedName)
);

export const getPersonChangedSurname: (state: {
  person: PersonFields;
}) => string = createSelector(getPerson, ({ changedSurname }) =>
  getValue(changedSurname)
);

export const getPersonChangedPatronimic: (state: {
  person: PersonFields;
}) => string = createSelector(getPerson, ({ changedPatronimic }) =>
  getValue(changedPatronimic)
);

export const getPersonBirthPlace: (state: {
  person: PersonFields;
}) => string = createSelector(getPerson, ({ birthPlace }) =>
  getValue(birthPlace)
);

export const getPersonCitizenship: (state: {
  person: PersonFields;
}) => CITIZENSHIP = createSelector(getPerson, ({ citizenship }) =>
  getValue(citizenship)
);

export const validatePersonChangedName: (state: {
  person: PersonFields;
}) => boolean = createSelector(
  getPersonChangedName,
  didPersonChangedName,
  (name, hasChangedName) => hasChangedName && isNameValid(name)
);

export const validatePersonChangedSurname: (state: {
  person: PersonFields;
}) => boolean = createSelector(
  getPersonChangedSurname,
  didPersonChangedName,
  (name, hasChangedName) => hasChangedName && isNameValid(name)
);

export const validatePersonChangedPatronimic: (state: {
  person: PersonFields;
}) => boolean = createSelector(
  getPersonChangedPatronimic,
  didPersonChangedName,
  (name, hasChangedName) => hasChangedName && isNameValid(name)
);

export const validatePersonChangedNameDocIssuer: (state: {
  person: PersonFields;
}) => boolean = createSelector(
  getPersonChangeNameDocIssuer,
  didPersonChangedName,
  (changeNameDocIssuer, hasChangedName) =>
    hasChangedName && notEmptyField(changeNameDocIssuer)
);

export const validatePersonBirthPlace: (state: {
  person: PersonFields;
}) => boolean = createSelector(getPersonBirthPlace, (value) =>
  notEmptyField(value)
);
